module.exports = __webpack_public_path__ + "files/b0e6f8f20d731bbca50bf5bbb9fa184b.png";